
import { defineComponent, PropType } from 'vue';
import useDialogVisible from '@/hooks/use-dialog-visible';
import type {
  IManageProjectNewProcessListItem,
} from '@/api/project-service/type.d';
import {
  APPROVAL_PROCESS_TYPE_ENUM,
  APPROVAL_PROCESS_TYPE_LIST,
} from '@/constant/project-service';

export default defineComponent({
  name: 'ApprovalProcess',
  emits: ['update:modelValue'],
  props: {
    modelValue: Boolean,
    dataList: {
      type: Array as PropType<IManageProjectNewProcessListItem[]>,
    },
  },
  setup(props, { emit }) {
    const { visible } = useDialogVisible(props, emit);
    return {
      visible,
      APPROVAL_PROCESS_TYPE_ENUM,
      APPROVAL_PROCESS_TYPE_LIST,
    };
  },
});
